import type { CorrelationsPublishStatus } from '@library/types/correlations';
import { useState } from 'react';

export const useCorrelationsPublishStatus = () => {
  const intialStatus = {
    isError: false,
    isLoading: false,
    isSuccess: false,
    errors: [],
    message: ''
  };

  const [publishStatus, setPublishStatus] =
    useState<CorrelationsPublishStatus>(intialStatus);

  const resetPublishStatus = () => {
    const { isError, isSuccess } = publishStatus;

    if (isError || isSuccess) {
      setPublishStatus(intialStatus);
    }
  };

  return {
    publishStatus,
    resetPublishStatus,
    setPublishStatus
  };
};
